import { ExposureMetric } from '@/types/AccountExposure';

export function GetPrefixSymbolFromExposureMetric(value: ExposureMetric): string {
  if (value.unitOfMeasure === 'USD') {
    return '$';
  } else {
    return '';
  }
}

export function GetSuffixSymbolFromExposureMetric(value: ExposureMetric): string {
  if (value.unitOfMeasure === 'USD') {
    return '';
  } else {
    return value.unitOfMeasure;
  }
}

export function GetScaleFromExposureMetric(value: ExposureMetric): string {
  if (value.unitOfMeasure === 'USD') {
    switch (value.unitScale) {
      case 'M': return 'Millions';
      case 'B': return 'Billions';
      case 'T': return 'Trillions';
      default:  return '';
    }
  } else {
    return value.unitOfMeasure;
  }
}
